import { keepPreviousData } from "@tanstack/react-query"

import { useFindContactrMapping } from "~/gen/api/hooks"
import { FindContactrMappingQueryParams } from "~/gen/api/types"

export const useFindContactsQuery = ({
  searchSupplier,
}: FindContactrMappingQueryParams) =>
  useFindContactrMapping(
    {
      searchSupplier,
    },
    {
      query: {
        placeholderData: keepPreviousData,
      },
    }
  )
